export default function LabelPrint({ ticket }) {
  if (!ticket) return null;
  return (
    <div id="printable-label" className="hidden print:block">
      <div style={{ fontWeight: 800, fontSize: 14, letterSpacing: "-0.02em" }}>{ticket.ticket_number}</div>
      <div style={{ fontSize: 11, fontWeight: 600, marginTop: 2 }}>{ticket.customer_name} · {ticket.customer_phone}</div>
      <div style={{ fontSize: 10 }}>{ticket.device_make} {ticket.device_model}</div>
      {ticket.imei ? <div style={{ fontSize: 9, fontFamily: "'IBM Plex Mono', monospace" }}>IMEI {ticket.imei}</div> : null}
      <div style={{ fontSize: 9, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {ticket.issue}
      </div>
      <div style={{ fontSize: 9, marginTop: 2 }}>EST ${Number(ticket.estimated_cost || 0).toFixed(2)}</div>
    </div>
  );
}
